module.exports = __webpack_public_path__ + "img/home_hover_story_card2.b22fbc3a.svg";